var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end gap-x-2"},[_c('base-button',{attrs:{"disabled":!_vm.canValidate},on:{"click":_vm.onValidate}},[_vm._v("Validasi")]),_c('router-link',{attrs:{"to":_vm.backRoute}},[_c('base-button',{attrs:{"color":"white"}},[_vm._v("Kembali")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }